export default __webpack_public_path__ + "static/media/Banner - EarBuddyz - Black.28aba338.jpg";